module.exports = __webpack_public_path__ + "static/media/twitter.3a6f77f8.svg";